import { IconButton } from '@mui/material';
import { RefactoredDevice } from '../../../@types/model/device';
import { checkRoles, ROLE_USER } from 'guards/CheckRoles';
import { Fragment } from 'react';
import SvgIconStyle from 'components/SvgIconStyle';
import { PATH_DASHBOARD } from 'routes/paths';
import { generatePath } from 'react-router';
import { NavLink } from 'react-router-dom';

interface GridImagePercentProps {
  rd: RefactoredDevice;
  user: any;
  setDeviceToShare: (rd: RefactoredDevice) => void;
}

const GridImagePercent = (props: GridImagePercentProps) => {
  return (
    <Fragment>
      <div
        className="itemImageLayer"
        style={
          props.rd.device_type === 'glp'
            ? {
                marginLeft: 'calc(50% - 40px)',
                width: '80px'
              }
            : {}
        }
      ></div>
      {props.rd.device_type !== 'water' && (
        <div
          className="itemImagePercent"
          style={
            props.rd.device_type === 'glp'
              ? {
                  background: props.rd.backgroundPercent,
                  top: 110 - (30 + props.rd.percent * 0.4) * 0.9,
                  height: (30 + props.rd.percent * 0.4) * 0.9
                }
              : {
                  background: props.rd.backgroundPercent,
                  top: 110 - props.rd.percent * 0.9,
                  height: props.rd.percent * 0.9
                }
          }
        ></div>
      )}
      {props.rd.device_type === 'silo' && (
        <img src="/static/silo.png" alt="Silo" className="itemImageSilo" />
      )}
      {props.rd.device_type === 'glp' && (
        <img src="/static/glp.png" alt="Deposito GLP" className="itemImageGlp" />
      )}
      {props.rd.device_type === 'water' && (
        <img src="/static/contador.png" alt="Contador de agua" className="itemImageContador" />
      )}
      {props.rd.device_type === 'deposito' && (
        <img src="/static/deposito.png" alt="Deposito" className="itemImageDeposito" />
      )}

      {props.rd.device_type === 'beer' && (
        <img src="/static/beer.png" alt="Beer" className="itemImageBeer" />
      )}
      {props.rd.device_type !== 'water' && (
        <div
          className="itemImageText"
          style={
            props.rd.device_type === 'glp'
              ? {
                  top: 17,
                  color: props.rd.colorPercent
                }
              : {
                  color: props.rd.colorPercent
                }
          }
        >
          {Math.round(props.rd.percent)}%
        </div>
      )}
      {checkRoles(props.user, ROLE_USER) ? (
        <div className="itemImageButtons">
          <IconButton
            onClick={() => {
              props.setDeviceToShare(props.rd);
            }}
          >
            <SvgIconStyle src="/static/icons/giraf/share.svg" className="svgShare" />
          </IconButton>
          <IconButton
            component={NavLink}
            disabled={props.rd.attributes.is_ref_of !== null}
            to={generatePath(PATH_DASHBOARD.devices.edit, { guid: props.rd.guid })}
          >
            <SvgIconStyle className="svgShare" src="/static/icons/giraf/edit.svg" />
          </IconButton>
        </div>
      ) : null}
    </Fragment>
  );
};

export default GridImagePercent;
